import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20Chinese%20film%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20abstract%20flowing%20light%20streaks%20reminiscent%20of%20film%20reel%2C%20soft%20bokeh%20texture%2C%20elegant%20dark%20gradient%20background%20with%20subtle%20lens%20flare%2C%20luxurious%20cinematic%20mood%2C%20no%20text%2C%20no%20people%2C%20artistic%20rendering&width=1800&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="国产视频在线观看 - 高清影视平台"
          title="国产视频在线观看·高清免费全集播放"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-[900px] mx-auto text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          国产视频在线观看
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-[680px] mx-auto">
          海量高清国产影视剧、综艺、纪录片免费在线播放。无需下载，随时随地流畅观看最新国产内容，
          支持手机、平板、电脑多端同步，每日更新热门国产视频资源。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 text-white backdrop-blur-sm rounded-full font-semibold text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
          >
            <i className="ri-movie-line mr-2"></i>
            热门电影
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">10万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">视频资源</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5000万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">月活用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">4K</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">超清画质</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}